'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'car-burst';
var width = 640;
var height = 512;
var aliases = ["car-crash"];
var unicode = 'f5e1';
var svgPathData = 'M216 8.1l0-48c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8s8-3.6 8-8zM24 152.1l48 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8s3.6 8 8 8zM298.5 53.6c3.1 3.1 8.2 3.1 11.3 0l33.9-33.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L298.5 42.3c-3.1 3.1-3.1 8.2 0 11.3zM83.5 279.9l33.9-33.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L72.2 268.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zM72.2 8.3c-3.1 3.1-3.1 8.2 0 11.3l33.9 33.9c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L83.5 8.3c-3.1-3.1-8.2-3.1-11.3 0zM344.1 123.4l194.6 52.1c16.9 4.5 28.9 19.5 29.6 37l3.6 88.1c-1.6-.6-3.3-1.1-5-1.5L257.9 216.2c-1.7-.5-3.4-.8-5.1-1.1L300 140.6c9.4-14.8 27.2-21.8 44.1-17.2zm-57.7 8.7l-52.2 82.4c-25.5 2.8-47.8 20.8-54.8 47.1l-24.8 92.7c-2.1 7.7-6.2 23.2-12.4 46.4-4.6 17.1 5.6 34.6 22.6 39.2s34.6-5.6 39.2-22.6l8.3-30.9 309.1 82.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2s34.6-5.6 39.2-22.6c10.4-38.6 16.6-61.8 37.3-139.1 7-26.2-3.3-53-23.9-68.2l-4-97.4c-1-24.5-17.8-45.5-41.5-51.8L348.3 107.9c-23.7-6.3-48.7 3.4-61.8 24.1zM541 457.7l-15.5-4.1-309.1-82.8c-7.7-2.1-23.2-6.2-46.4-12.4l24.8-92.7c6.9-25.6 33.2-40.8 58.8-33.9l309.1 82.8c25.6 6.9 40.8 33.2 33.9 58.8L571.9 466 541 457.7zm-12.4 46.4l8.3-30.9 30.9 8.3-8.3 30.9c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6zm-331.7-122L188.6 413c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l8.3-30.9 30.9 8.3zm55.8-84.4a16 16 0 1 1 30.9 8.3 16 16 0 1 1 -30.9-8.3zM299 310.1a32 32 0 1 0 -61.8-16.6 32 32 0 1 0 61.8 16.6zm220.5 42.5a16 16 0 1 1 -8.3 30.9 16 16 0 1 1 8.3-30.9zm-12.4 46.4a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarBurst = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;